import { createSelector } from 'reselect'
import colorUtils from '../../utils/color'

import {
  DEFAULT_PROJECT_SETTINGS,
} from '../../settings'

const data = state => state.project.data
const joinWindow = state => state.project.joinWindow
const userMeta = state => state.project.userMeta
const projectData = state => state.project.project

const project = createSelector(
  projectData,
  (project) => {
    if(!project) return null
    const settings = project.settings || DEFAULT_PROJECT_SETTINGS
    const items = project.items.map(item => {
      const color = colorUtils.getColor({
        settings,
        threshold: item.threshold,
      })
      return Object.assign({}, item, {
        color,
      })
    })
    return Object.assign({}, project, {
      settings,
      items,
    })
  }
)

const selectors = {
  data,
  joinWindow,
  userMeta,
  project,
}

export default selectors
